import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { ReportEffects } from './state/effects/report.effects';
import { reportFeature } from './state/reducer/report.reducer';

export const REPORT_STORE_PROVIDERS = {
  feature: provideState(reportFeature),
  effects: provideEffects(ReportEffects),
};
